import { FC } from 'react';
import { css } from '@emotion/react';
import { isWeaveUser } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { generateTrackingId } from '../../utils/tracking';

interface ActionButtonsProps {
  isEditMode: boolean;
  cancelEditMode: () => void;
  handleFieldSave: () => void;
  isFormLevelSaveDisabled: boolean;
  isFormComplete: boolean;
  isLoading: boolean;
  isDemoAccount: boolean;
}

export const ActionButtons: FC<ActionButtonsProps> = ({
  isEditMode,
  cancelEditMode,
  handleFieldSave,
  isFormLevelSaveDisabled,
  isFormComplete,
  isLoading,
  isDemoAccount,
}) => {
  const { t } = useTranslation('callIntelInsights');

  if (!isEditMode) return null;

  return (
    <div css={styles.actionBtnWrapper}>
      <Button
        variant='secondary'
        onClick={cancelEditMode}
        trackingId={generateTrackingId({
          component: 'call-analysis',
          context: 'cancel-btn-click',
          isDemoAccount,
        })}
      >
        {t('Cancel')}
      </Button>
      <Button
        css={css`
          min-width: 120px;
        `}
        disabled={isWeaveUser() || isFormLevelSaveDisabled || !isFormComplete}
        loading={isLoading}
        variant='primary'
        trackingId={generateTrackingId({
          component: 'call-analysis',
          context: 'save-btn-click',
          isDemoAccount,
        })}
        hoverLabel={
          isWeaveUser()
            ? t(
                'This feature is intended solely for Weave customers to correct AI outputs perceived as wrongly classified.'
              )
            : undefined
        }
        showLabelWhenDisabled
        onClick={handleFieldSave}
      >
        {t('Save Changes')}
      </Button>
    </div>
  );
};

const styles = {
  actionBtnWrapper: css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(1)};
    justify-content: flex-end;
  `,
};
